<!-- logos -->
<div id="navBar">
  <div class="navbar_item">
    <a routerLink="/">
      <div id="navbar-logoContainer">
        <div class="navbar-svg-container">
          <div class="navbar-image ml-12">
            <img src="assets/images/logo-airlines-white.svg" width="100%" height="100%" class="navbar-svg-content" alt="">
          </div>
        </div>
      </div>
    </a>
  </div>

  <div class="navbar_item profile">
    <div [ngClass]="{'change-bp': isAdmin}"
      (click)="isAdmin ? openDialogChangeBp(): null"
      [title]="isAdmin ? 'Alterar BP': ''">
      <img class="profile-photo_user" [src]="photo ? photo : 'assets/images/blank-profile-picture.svg'" alt="Foto de Perfil"/>
    </div>
    @if (name) {
      <div class="profile-name_container"
        [ngClass]="{ 'edit-external_crew': isExternal }"
        (click)="isExternal ? openDialogEditExternalCrew(): null"
        [title]="isExternal ? 'Alterar Dados': ''">
        <span class="profile-name">{{ name }}</span>
      </div>
    }
  </div>

  <div class="navbar_item item-logout">
    <div class="logout" (click)="logout()">
      <span>Logout</span>
      <div class="logout-icon_container">
        <img class="logout-icon" src="assets/images/logout.svg" alt="Logout"/>
      </div>
    </div>
    <div class="eclipse-img_container">
      <img class="eclipse-img" src="assets/images/eclipse.svg" alt="Eclipse" />
    </div>
  </div>
</div>
